import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MensagensService } from 'max-ng-lib';

import { ParametroModel } from '../content/pages/components/configuracoes/parametros/parametro.model';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { Observable } from 'rxjs';
import { enumTipoParametro } from '../core/enums/enums';

@Injectable({ providedIn: 'root' })
export class ParametroPortalService extends GenericServicesMotoristaService {
  
  private naoExibirParamGeralGestores = true;

  constructor(private _mensagensService: MensagensService,
    private _httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/parametroPortal';
  }

  listarParametrosPortal() {
    return this.get<any[]>('/listar-parametros-portal');
  }
  
  listarParametrosTipoPortal( tipoParametro: string = enumTipoParametro.FILIAL) {
    return this.get<ParametroModel[]>(`/listar-parametros-portal/${tipoParametro}`);
  }

listarParametrosPortalPersonalizado(filtro: any) {
  return this.post<ParametroModel[]>(`/listarParametrosPortalPersonalizado`, {
    dados: filtro
  });
}

  permiteFinalizarEntregas() {
    return this.get<{ id: number, valor: string }>('/permiteFinalizarEntregas');
  }

  salvarParametros(parametroModel: ParametroModel) {
    return this.post<ParametroModel>('/salvar', { dados: parametroModel });
  }

  agruparPainelMonitoramento() {
	  return this.get<any>('/agruparPainelMonitoramento');
  }

  obterParametroPorTipos(...tipoParametros: Array<string>) {
	return this.get<ParametroModel[]>('/obterPorTipos', {dados: {tipoParametros}});
  }

  naoExibirParametrosGeraisGestor() {
    return this.get<boolean>('/naoExibirParametrosGerais');
  }

  setNaoExibirParametrosGeraisGestor(valor: boolean) {
    this.naoExibirParamGeralGestores = valor;
  }

  getNaoExibirParametrosGeraisGestor() {
    return this.naoExibirParamGeralGestores;
  }
}
